import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass(`font-medium text-gray-900 dark:text-neutral-200 flex items-center gap-2`)
}
const _hoisted_4 = { class: "flex items-center gap-2 align-middle" }
const _hoisted_5 = {
  class: /*@__PURE__*/_normalizeClass(`rounded-full flex items-center justify-center`)
}
const _hoisted_6 = { class: "truncate text-neutral-800 dark:text-neutral-200 font-medium" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import type { DropdownMenuItem } from "#ui/types";
import type FamilyGroup from "../../../../backend/app/models/family_group";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupDropdown',
  props: {
    collapsed: { type: Boolean }
  },
  setup(__props: any) {

const familyGroupsStore = useGroupStore();

const props = __props;

// Get user's available groups from store
const userGroups = computed(() => familyGroupsStore.userGroups);

const items = computed(() => {
  if (!userGroups.value.length) return [[]];

  return [
    [
      {
        slot: "current-group",
        label: "",
        disabled: true,
      },
    ],
    userGroups.value.map(
      (group) =>
        ({
          label: group.name,
          icon: `i-${group.icon}`,
          color: group.color,
          onClick: () => familyGroupsStore.setCurrentSelectedGroup(group),
          id: group.id,
        }) as DropdownMenuItem,
    ),
  ];
});

const currentGroup = useState<FamilyGroup | null>("familyGroup.currentSelectedGroup");

return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UDropdownMenu = _resolveComponent("UDropdownMenu")!

  return (_unref(userGroups).length > 1)
    ? (_openBlock(), _createBlock(_component_UDropdownMenu, {
        key: 0,
        mode: "click",
        items: _unref(items),
        popper: { placement: 'bottom-start' }
      }, {
        "current-group": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Current Group", -1)),
            _createElementVNode("p", _hoisted_3, [
              (_unref(currentGroup))
                ? (_openBlock(), _createBlock(_component_UIcon, {
                    key: 0,
                    name: `i-${_unref(currentGroup).icon}`,
                    class: _normalizeClass(`text-${_unref(currentGroup).color}-500`)
                  }, null, 8, ["name", "class"]))
                : (_openBlock(), _createBlock(_component_UIcon, {
                    key: 1,
                    name: "i-heroicons-building-office",
                    class: "text-gray-400"
                  })),
              _createTextVNode(" " + _toDisplayString(_unref(currentGroup)?.name || "No group selected"), 1)
            ])
          ])
        ]),
        item: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              ('icon' in item)
                ? (_openBlock(), _createBlock(_component_UIcon, {
                    key: 0,
                    name: item.icon,
                    class: _normalizeClass(`bg-${item.color}-900 rounded-full size-5`)
                  }, null, 8, ["name", "class"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_UButton, {
            variant: `${props.collapsed ? 'solid' : 'subtle'}`,
            color: (_unref(currentGroup)?.color as any) || 'gray',
            block: "",
            class: _normalizeClass(` text-neutral-800 dark:text-neutral-200 truncate w-full flex flex-row justify-start items-center min-h-[32px]`)
          }, {
            default: _withCtx(() => [
              (_unref(currentGroup))
                ? (_openBlock(), _createBlock(_component_UIcon, {
                    key: 0,
                    name: `i-${_unref(currentGroup).icon}`,
                    class: _normalizeClass(`bg-${_unref(currentGroup).color}-500 size-5 min-w-5`)
                  }, null, 8, ["name", "class"]))
                : (_openBlock(), _createBlock(_component_UIcon, {
                    key: 1,
                    name: "i-heroicons-building-office",
                    class: "bg-neutral-500 dark:bg-neutral-200 size-5 min-w-5"
                  })),
              (!props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(currentGroup)?.name || "Select Group"), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["variant", "color"])
        ]),
        _: 1
      }, 8, ["items"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_UButton, {
          variant: `${props.collapsed ? 'solid' : 'ghost'}`,
          color: (_unref(currentGroup)?.color as any) || 'gray',
          class: _normalizeClass(` text-neutral-800 dark:text-neutral-200 max-h-8 truncate  border-none border-0 ${props.collapsed ? 'min-w-10 min-h-10' : 'min-w-20 w-40 max-w-40'}`)
        }, {
          default: _withCtx(() => [
            (_unref(currentGroup))
              ? (_openBlock(), _createBlock(_component_UIcon, {
                  key: 0,
                  name: `i-${_unref(currentGroup).icon}`,
                  class: _normalizeClass(`bg-${_unref(currentGroup).color}-500 size-5 min-w-5`)
                }, null, 8, ["name", "class"]))
              : (_openBlock(), _createBlock(_component_UIcon, {
                  key: 1,
                  name: "i-heroicons-building-office",
                  class: "bg-neutral-500 dark:bg-neutral-200 size-5 min-w-5"
                })),
            (!props.collapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(currentGroup)?.name || "Select Group"), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["variant", "color", "class"])
      ]))
}
}

})